function initHulkAccordionOptions() {
  if (window.hulkAccordionOptionsBound) {
    return;
  }
  window.hulkAccordionOptionsBound = true;

  $(document).on('click', '.hulkapps_option.dd_render > .hulkapps_option_name, .hulkapps_option.button_render > .hulkapps_option_name', function () {
    var $option = $(this).closest('.hulkapps_option');
    $option.toggleClass('hulk_option_expanded');
  });

  $(document).on('change', '.hulkapps_option.dd_render select.hulk_po_dropdown', function () {
    var $name = $(this).closest('.hulkapps_option.dd_render').find('> .hulkapps_option_name');
    updateHulkDropdownLabel($name, $(this));
  });

  function updateHulkDropdownLabel($name, $select) {
    var $options = $select.find('option');
    var $placeholderOption = $options.first();

    var selectedText = $select.find('option:selected').text().trim();
    var placeholder = $placeholderOption.text().trim();
    var text = selectedText && selectedText !== placeholder ? selectedText : placeholder;
    var label = text ? ': ' + text : '';
    $name.attr('data-selected-label', label);
  }

  function updateHulkButtonLabel($name, $selectedChild) {
    var selectedText = $selectedChild.find('> span').first().text().trim();
    var label = selectedText ? ': ' + selectedText : '';
    $name.attr('data-selected-label', label);
  }

  function updateHulkButtonPlaceholder($name, $option) {
    var $firstChild = $option.find('.hulkapps_option_child').filter(':visible').first();
    if (!$firstChild.length) {
      $firstChild = $option.find('.hulkapps_option_child').first();
    }
    var placeholder = $firstChild.find('> span').first().text().trim();
    var label = placeholder ? ': ' + placeholder : '';
    $name.attr('data-selected-label', label);
  }

  function refreshAllHulkDropdownLabels() {
    $('.hulkapps_option.dd_render select.hulk_po_dropdown').each(function () {
      var $name = $(this).closest('.hulkapps_option.dd_render').find('> .hulkapps_option_name');
      updateHulkDropdownLabel($name, $(this));
    });

    $('.hulkapps_option.button_render').each(function () {
      var $name = $(this).find('> .hulkapps_option_name');
      var $selected = $(this).find('.hulkapps_option_child.button_selected').filter(':visible').first();
      if ($selected.length) {
        updateHulkButtonLabel($name, $selected);
      } else {
        updateHulkButtonPlaceholder($name, $(this));
      }
    });

    stripSizePrefixFromOptionNames();
    boldSwatchLabelFirstWord();
    ensureHulkAccordionIcons();
    fixHulkSelectedValueSeparator();
  }

  // The value stays hidden (see .hulk-selected-value in hulk-custom.css) until
  // markReady is true, so the raw "- Value" text from Hulk is never visible.
  function fixHulkSelectedValueSeparator($scope, markReady) {
    var $values = $scope && $scope.length ? $scope.filter('.hulk-selected-value') : $('.hulk-selected-value');
    $values.each(function () {
      var $value = $(this);
      var text = $value.text();
      var trimmed = text.replace(/^\s*-\s*/, '');
      if (trimmed !== text.replace(/^\s+/, '')) {
        $value.text(': ' + trimmed);
      }
      if (markReady) {
        $value.addClass('hulk-sv-ready');
      }
    });
  }

  // Per-product metafield list of "Option title: open|closed" lines
  // (e.g. "Availability: open", "Base: closed") sets each option's initial
  // accordion state. Options not listed fall back to the theme default.
  var hulkAccordionMap = null;

  function getHulkAccordionMap() {
    if (hulkAccordionMap !== null) {
      return hulkAccordionMap;
    }
    hulkAccordionMap = {};
    var dataEl = document.getElementById('hulk-accordion-data');
    if (dataEl) {
      try {
        var list = JSON.parse(dataEl.textContent);
        if (!Array.isArray(list)) {
          list = [list];
        }
        list.forEach(function (line) {
          var index = String(line).lastIndexOf(':');
          if (index > 0) {
            hulkAccordionMap[line.slice(0, index).trim().toLowerCase()] = line.slice(index + 1).trim().toLowerCase();
          }
        });
      } catch (e) {}
    }
    return hulkAccordionMap;
  }

  function ensureHulkAccordionIcons() {
    var accordionMap = getHulkAccordionMap();
    $('.hulkapps_option.dd_render > .hulkapps_option_name, .hulkapps_option.button_render > .hulkapps_option_name').each(function () {
      var $name = $(this);
      if (!$name.children('.hulk-accordion-icon').length) {
        $name.append('<span class="hulk-accordion-icon"></span>');
      }
      var $option = $name.closest('.hulkapps_option');
      if ($option.data('hulkAccordionInit')) {
        return;
      }
      var title = ($name.attr('aria-label') || $name.text()).trim().toLowerCase();
      var state = accordionMap[title];
      if (state === 'open' || state === 'closed' || state === 'close') {
        $option.data('hulkAccordionInit', true).toggleClass('hulk_option_expanded', state === 'open');
      } else if (window.theme && window.theme.hulkAccordionOpen) {
        $option.data('hulkAccordionInit', true).addClass('hulk_option_expanded');
      }
    });
  }

  // Hulk option/choice titles are sometimes configured per-size on the
  // backend (e.g. "96″ Slipcover", "108″ Organic Upgrade") so pricing and
  // conditional logic can target a specific size, but the PDP should show
  // one common label ("Slipcover", "Organic Upgrade") no matter which size
  // is active. This only ever touches visible text nodes, never the
  // data-conditional-value/value attributes that drive pricing/logic.
  var hulkSizePrefix = /^(?:[^-]*\s*-\s*|\s*\d+\s*(?:["″]|in\.?|inch(?:es)?)?\s+)/i;

  function stripLeadingSizeFromFirstTextNode(el) {
    var node = el.firstChild;
    while (node) {
      if (node.nodeType === 3 && node.nodeValue.replace(/\s/g, '')) {
        var stripped = node.nodeValue.replace(hulkSizePrefix, '');
        if (stripped !== node.nodeValue) {
          node.nodeValue = stripped;
        }
        return;
      }
      node = node.nextSibling;
    }
  }

  function stripSizePrefixFromOptionNames() {
    $('.hulkapps_option_name').each(function () {
      stripLeadingSizeFromFirstTextNode(this);
    });

    $('.hulkapps_check_option, .hulkapps_radio_option').each(function () {
      stripLeadingSizeFromFirstTextNode(this);
    });
  }

  function boldSwatchLabelFirstWord() {
    $('.hulkapps_swatch_option > div:last-child').each(function () {
      var $label = $(this);
      if ($label.data('hulkBoldApplied')) {
        return;
      }
      var text = $label.text().trim();
      if (!text) {
        return;
      }
      var spaceIndex = text.indexOf(' ');
      var firstWord = spaceIndex === -1 ? text : text.slice(0, spaceIndex);
      var rest = spaceIndex === -1 ? '' : text.slice(spaceIndex);
      $label.empty()
        .append($('<b>').text(firstWord))
        .append(rest ? $('<br>') : '')
        .append(rest ? $('<span>').text(rest) : '')
        .data('hulkBoldApplied', true);
    });
  }

  // Lead time text comes from the product metafield as a list of
  // "Option: text" lines (e.g. "Quick Ship: ships in 2 days"). The line whose
  // prefix matches the selected Availability option is shown under the buttons.
  // Not tied to an option title: any button option whose selected value
  // matches a metafield prefix gets the note.
  var hulkLeadTimeMap = null;

  function getHulkLeadTimeMap() {
    if (hulkLeadTimeMap !== null) {
      return hulkLeadTimeMap;
    }
    hulkLeadTimeMap = {};
    var dataEl = document.getElementById('hulk-lead-time-data');
    if (dataEl) {
      try {
        var list = JSON.parse(dataEl.textContent);
        if (!Array.isArray(list)) {
          list = [list];
        }
        list.forEach(function (line) {
          line = String(line);
          var index = line.indexOf(':');
          if (index > 0) {
            hulkLeadTimeMap[line.slice(0, index).trim().toLowerCase()] = line.slice(index + 1).trim();
          }
        });
      } catch (e) {}
    }
    return hulkLeadTimeMap;
  }

  // Tooltip text comes from the product's shipping_details metafield and is
  // the same for every option value.
  function getHulkShippingTooltip() {
    var el = document.getElementById('hulk-shipping-details-data');
    if (!el) {
      return '';
    }
    try {
      var value = JSON.parse(el.textContent);
      return Array.isArray(value) ? value.join(' ').trim() : String(value || '').trim();
    } catch (e) {
      return '';
    }
  }

  function updateHulkLeadTime($clicked) {
    var map = getHulkLeadTimeMap();
    $('.hulkapps_option.button_render').each(function () {
      var $option = $(this);
      var $selected = $clicked && $clicked.closest(this).length
        ? $clicked
        : $option.find('.hulkapps_option_child.button_selected').first();
      var key = $selected.find('> span').first().text().trim().toLowerCase();
      var text = key ? map[key] : '';
      var item = text ? { text: text, tooltip: getHulkShippingTooltip() } : null;
      var $note = $option.find('> .hulk-lead-time');
      if (!item) {
        $note.remove();
        return;
      }
      if (!$note.length) {
        $note = $('<div class="hulk-lead-time ctMsg"></div>').appendTo($option);
      }
      var signature = item.text + '||' + item.tooltip;
      if ($note.data('hulkSignature') === signature) {
        return;
      }
      $note.empty().append(document.createTextNode(item.text + ' '));
      if (item.tooltip) {
        $note.append(
          $('<span class="un-tip-wrap"></span>')
            .append($('<span class="un-tip-icon">?</span>'))
            .append($('<span class="un-tip-text"></span>').text(item.tooltip))
        );
      }
      $note.data('hulkSignature', signature);
    });
  }

  // Update instantly from the clicked button instead of waiting for Hulk
  // to re-render and add button_selected.
  $(document).on('click', '.hulkapps_option.button_render .hulkapps_option_child', function () {
    // Cheap per-click update of just this option's header label (no global refresh).
    var $child = $(this);
    updateHulkButtonLabel($child.closest('.hulkapps_option').find('> .hulkapps_option_name'), $child);
    updateHulkLeadTime($child);
  });

  // Cheap text-only fixes (no :visible, no label/auto-select logic). Hulk renders
  // and re-renders options after our init, so run these shortly after load and
  // after each click/change instead of using a MutationObserver.
  var hulkTextFixTimers = [];
  function scheduleHulkTextFixes(delays) {
    hulkTextFixTimers.forEach(clearTimeout);
    hulkTextFixTimers = delays.map(function (delay) {
      return setTimeout(function () {
        stripSizePrefixFromOptionNames();
        boldSwatchLabelFirstWord();
        ensureHulkAccordionIcons();
        fixHulkSelectedValueSeparator();
      }, delay);
    });
  }

  $(document).on('click change', '[id^="hulkapps_options_"]', function () {
    scheduleHulkTextFixes([150, 300, 600]);
  });
  scheduleHulkTextFixes([300, 1000, 2500]);

  // Hulk rewrites the swatch value text ("- Archer Eucalyptus") whenever it
  // likes (picks, price/conditional updates), so timers can't keep up and the
  // label flips between "-" and ":". Watch just that one small element instead
  // of the whole options tree: the callback runs before paint, so "-" never shows.
  function watchHulkSelectedValue(el) {
    var $el = $(el);
    if ($el.data('hulkValueWatched') || !window.MutationObserver) {
      return;
    }
    $el.data('hulkValueWatched', true);
    new MutationObserver(function () {
      fixHulkSelectedValueSeparator($el, true);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  // CSS animation hooks in hulk-custom.css fire animationstart when Hulk inserts
  // a swatch value, a select, or marks a button button_selected. Event-driven,
  // so no MutationObserver is needed.
  // Skeleton (see hulk-custom.css) covers Hulk's raw first render. Reveal each
  // options wrapper once its elements have stopped appearing and the tidy-up
  // has run: 300ms after the last hook event, or 4s at the latest.
  var hulkSkeletonSelector = '[id^="hulkapps_options_"]';

  function revealHulkOptions($root) {
    if ($root.hasClass('hulk-ready')) {
      return;
    }
    clearTimeout($root.data('hulkRevealTimer'));
    clearTimeout($root.data('hulkRevealMax'));
    refreshAllHulkDropdownLabels();
    fixHulkSelectedValueSeparator(null, true);
    updateHulkLeadTime();
    $root.addClass('hulk-ready');
  }

  function scheduleHulkReveal($root) {
    if (!$root.length || $root.hasClass('hulk-ready')) {
      return;
    }
    clearTimeout($root.data('hulkRevealTimer'));
    $root.data('hulkRevealTimer', setTimeout(function () {
      revealHulkOptions($root);
    }, 300));
    if (!$root.data('hulkRevealMax')) {
      $root.data('hulkRevealMax', setTimeout(function () {
        revealHulkOptions($root);
      }, 4000));
    }
  }

  document.addEventListener('animationstart', function (e) {
    if (e.animationName.indexOf('hulk') === 0 && e.animationName.indexOf('hulkSkeleton') !== 0) {
      scheduleHulkReveal($(e.target).closest(hulkSkeletonSelector));
    }
    if (e.animationName === 'hulkValueHook') {
      fixHulkSelectedValueSeparator($(e.target), true);
      watchHulkSelectedValue(e.target);
      return;
    }
    if (e.animationName === 'hulkDropdownHook') {
      // Select was just inserted by Hulk; its value may be applied a moment
      // later, so read it after a short delay.
      var $select = $(e.target);
      [50, 400].forEach(function (delay) {
        setTimeout(function () {
          var $name = $select.closest('.hulkapps_option.dd_render').find('> .hulkapps_option_name');
          updateHulkDropdownLabel($name, $select);
          ensureHulkAccordionIcons();
          stripSizePrefixFromOptionNames();
        }, delay);
      });
      return;
    }
    if (e.animationName !== 'hulkSelectedHook') {
      return;
    }
    var $child = $(e.target);
    updateHulkButtonLabel($child.closest('.hulkapps_option').find('> .hulkapps_option_name'), $child);
  });

  // Options with nothing that fires a hook (e.g. only checkboxes) still get revealed.
  setTimeout(function () {
    $(hulkSkeletonSelector).each(function () {
      revealHulkOptions($(this));
    });
  }, 4000);

  refreshAllHulkDropdownLabels();
  updateHulkLeadTime();

  $(document).on('change', '.hulkapps_option.cb_render input[type="checkbox"]', function () {
    refreshAllHulkDropdownLabels();
  });
}

$( document ).ready(function() {
  initHulkAccordionOptions();
});

$( window ).on('load', function() {
  initHulkAccordionOptions();
});
